import { Grid, Typography } from '@mui/material'
import React from 'react'
import theme from '../../theme'

const Redirected = () => {
  return (
    <Grid sx={{height:"80vh"}} display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <Typography sx={{fontFamily:theme.font?.fontFamily.primary}}>You Have Been Redirected To Capillary</Typography>
    </Grid>
  )
}

export default Redirected